import styled from 'styled-components';

const FilterOptionContainer = styled.div<{ selected: boolean; color: string }>`
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  padding: 12px 0;
  transition: all 0.1s;
  display: block;
  color: ${({ selected, color }: { selected: boolean; color: string }) => (selected && (color))};

  &:hover {
    color: ${({ color }: {color: string}) => color};
  }
`;

export default FilterOptionContainer;
